import OutLook from './icon-microsoft-outlook.png';
import Teams from './icon-microsoft-teams.png';
import OneDrive from './icon-onedrive.png';

const images = {
  outlook: OutLook,
  teams: Teams,
  oneDrive: OneDrive,
};

export default images;
